import { CDBListGroup, CDBListGroupItem, CDBSpinner } from 'cdbreact';
import { useEffect, useState } from 'react';
import { get, put } from '../../api/usersModule/httpClient';
import {
	getProjectNameByID,
	getRoleNameByID,
	getRoleIDByName,
} from '../../api/usersModule/getters';

import Dropdown from 'react-bootstrap/Dropdown';
import swal from 'sweetalert';

export const ModalUserProjects = ({ UserName, UserID, nit }) => {
	const [projectsRolesUsers, setProjectsRolesUsers] = useState([]);
	const [roles, setRoles] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	const getRoles = async () => {
		try {
			setIsLoading(true);
			const roles = await get(`/roles?nit=${nit}`);
			const activeRoles = roles.items
				.filter((item) => item.active)
				.map((item) => item.nombreRole);
			setRoles(activeRoles);
			await getProjectsRolesUsers();
		} catch (error) {
			console.error(error);
			setRoles([]);
		} finally {
			setIsLoading(false);
		}
	};

	const getProjectsRolesUsers = async () => {
		const res = await get(`/projectsRolesUsers?userID=${UserID}`);
		res.items === null
			? setProjectsRolesUsers([])
			: setProjectsRolesUsers(res.items);

		const array = await convertIDsToNames(res.items);
		setProjectsRolesUsers(array);
	};

	const convertIDsToNames = async (items) => {
		let array = [];

		for (let i in items) {
			let projectName = await getProjectNameByID(items[i].Nit);
			let roleName = await getRoleNameByID(items[i].RoleID, nit);
			array.push({
				ProjectName: projectName,
				RoleName: roleName,
				RoleID: items[i].RoleID,
				Nit: items[i].Nit,
			});
		}

		return array;
	};

	const handleRoleChange = async (nit, roleName) => {
		const roleID = await getRoleIDByName(roleName, nit);
		const body = {
			Nit: 1,
			roleID: roleID,
			userID: UserID,
			user: UserName,
		};
		await put(`/projectsRolesUsers`, body)
			.then(() => {
				swal('¡Listo!', 'Se ha actualizado el rol del usuario', 'success');
			})
			.catch(() => {
				swal(
					'¡Error!',
					'No se ha podido actualizar el rol del usuario',
					'error'
				);
			})
			.finally(() => {
				getRoles();
			});
		await getProjectsRolesUsers();
	};

	useEffect(() => {
		if (roles.length === 0) {
			getRoles();
		}
    // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div>
			<div className='modal-header'>
				<div>
					<h3 className='modal-title'>Permisos de {UserName}</h3>
				</div>
			</div>
			{isLoading ? (
				<div className='d-flex justify-content-center'>
					<CDBSpinner />
				</div>
			) : (
				<div className='modal-body'>
					{projectsRolesUsers.map((item) => {
						return (
							<div>
								<CDBListGroup>
									<CDBListGroupItem>
										<div className='d-flex justify-content-between'>
											<p className='mt-2'>{item.ProjectName}</p>
											<Dropdown className='mt-2'>
												<Dropdown.Toggle caret='true'>
													Rol: {item.RoleName}
												</Dropdown.Toggle>
												<Dropdown.Menu>
													{roles.map((role) => {
														return (
															<Dropdown.Item
																key={role}
																onClick={() => {
																	handleRoleChange(item.Nit, role);
																}}
															>
																{' '}
																{role}{' '}
															</Dropdown.Item>
														);
													})}
												</Dropdown.Menu>
											</Dropdown>
										</div>
									</CDBListGroupItem>
								</CDBListGroup>
							</div>
						);
					})}
				</div>
			)}
		</div>
	);
};
